import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CpCompanyService {
  private host = environment.apiUrlHost;
  // logo company
  private pictureUrlSourceLogo = new BehaviorSubject<string| null>(null);
  pictureUrlLogo$ = this.pictureUrlSourceLogo.asObservable();
  // favicon (browser tab icon) - applied app-wide like logo
  private pictureUrlSourceFavIcon = new BehaviorSubject<string | null>(null);
  pictureUrlFavIcon$ = this.pictureUrlSourceFavIcon.asObservable();
  private comapnyName = new BehaviorSubject<string| null>(null);
  companyName$ = this.comapnyName.asObservable();
  constructor(private http: HttpClient, private router: Router) { }

  /**
   * Retrieves the company data from the server.
   *
   * @return {Observable<any>} The company data observable.
   */
  public getCompany(): Observable<any> {
    return this.http.get(`${this.host}/CP/cp_companyRetrive`);
  }

  /**
   * Updates the company data on the server.
   *
   * @param {any} company - The company data to be updated.
   * @return {Observable<any | HttpErrorResponse>} The result of the update operation, which can be either the updated company data or an HTTP error response.
   */
  public updateCompany(company: any): Observable<any | HttpErrorResponse> {
    return this.http.put<any>(`${this.host}/CP/cp_company/`, company);
  }
  
  updateLogoUrl(newUrl: string) {
    console.log('here is logo url updateLogoUrl', newUrl);
    this.pictureUrlSourceLogo.next(newUrl);
  }

  getCurrentLogoUrl(): string | null {
    return this.pictureUrlSourceLogo.value;
  }

  updateFavIconUrl(newUrl: string | null): void {
    this.pictureUrlSourceFavIcon.next(newUrl);
  }

  getCurrentFavIconUrl(): string | null {
    return this.pictureUrlSourceFavIcon.value;
  }

  getCurrentCompanyName(): string | null {
    return this.comapnyName.value;
  }

  updateComanyName(newName: string) {
    console.log('here is name update', newName);
    this.comapnyName.next(newName);
  }
}
